module.exports = __webpack_public_path__ + "ba972e25b838eae3895cd04b4245ecce.png";